module.exports = __webpack_public_path__ + "h5/img/dfh001.8b81ad44.gif";